import React from 'react';
import {Box} from '@mui/material';
import Loading from '../../../components/Loading/Loading';

export const LoadingOverlay: (entityName: string) => React.FC = (entityName) => {
  return () => (
    <Box p={5} flex={1} display="flex" justifyContent="center" alignContent="center">
      <Box>
        <Loading entityName={entityName} />
      </Box>
    </Box>
  );
};
